(function () {
    'use strict';

    angular.module("imApp").factory("usergroupTableEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 87,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 89,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
